export type GeneralErrorTranslation = {
  forbidden: ErrorTranslation;
  goBack: string;
  logIn: string;
  noSession: BootstrapErrorTranslation;
  notAuthorized: BootstrapErrorTranslation;
  notFound: ErrorTranslation;
  serviceUnavailable: BootstrapErrorTranslation;
  title: string;
  waitingForApproval: ErrorTranslation;
};

type BootstrapErrorTranslation = ErrorTranslation & {
  primaryAction: string;
  statusLabel: string;
};

type ErrorTranslation = {
  message: string;
  subMessage?: string;
};

export const generalErrorTranslation: GeneralErrorTranslation = {
  forbidden: {
    message: 'You are not authorized to access this site or your session has expired.',
    subMessage:
      'If you believe you should have access, ask your manager or supervisor to grant it.',
  },
  goBack: 'Go back',
  logIn: 'Log in',
  noSession: {
    message: 'You are not logged in',
    primaryAction: 'Log in',
    statusLabel: 'Session status',
    subMessage: 'Log in again to continue using jAIn.',
  },
  notAuthorized: {
    message: 'Access Denied',
    primaryAction: 'Go back',
    statusLabel: 'Access status',
    subMessage:
      'If you believe you should have access to the application, contact your administrator.',
  },
  notFound: {
    message: 'Page not found.',
  },
  serviceUnavailable: {
    message: "We couldn't connect",
    primaryAction: 'Try again',
    statusLabel: 'Gateway error',
    subMessage: 'Try again in a moment. If the problem continues, contact us:',
  },
  title: 'Oops! Something went wrong',
  waitingForApproval: {
    message: 'Your account is pending approval',
    subMessage: 'We will notify you once it is approved.',
  },
};
